
export class DocumentResponseGet {
    id: number;

    published: boolean;
    name: string;
    url: string;
    
    alt: string;
    summary: string;
    tags: string;
    copyright: string;
    filename: string;
    

    createdAt: string;
    createdBy: string;
    modifiedAt: string;
    modifiedBy: string;
    privateUrl: string;
    publicUrl: string;
    signedUrl:string;
    
    status: string;
    constructor(){
        this.published = true;
        this.status = 'ACTIVE'
    }
  }





export class DocumentResponse{
    id: number;
    name: string;
    published: boolean;
    url: string;
    internalUrl: string;
    privateUrl: string;
    publicUrl ?: string;
    
}
export class DocumentResponsePublish {
    id: number;
    name: string;
    url: string; 
    filename: string;
}





export class DocumentResponseData{
    id: number;
    name: string;
    published: boolean;
    url: string;
    createdAt: string;
    createdBy:string;
    filename: string;
    
}
export class DocumentResponseTable{
    data: DocumentResponseData[];
    limit: number;
    page: number;
    total: number;
    
}
export class DocumentResponseList extends DocumentResponseTable{
    constructor(){super();}
}
export class DocumentResponseSearch extends DocumentResponseTable{
    constructor(){super();}
}